import { normalizeApiError } from 'shared/api'

type ToolResult = {
  content: Array<{ type: 'text'; text: string }>
  isError?: boolean
}

export const TOOL_RESULT_ENVELOPE_KEY = 'salesmessage_tool_result'
export const TOOL_RESULT_ENVELOPE_VERSION = 1

type ToolResultEnvelope = {
  [TOOL_RESULT_ENVELOPE_KEY]: typeof TOOL_RESULT_ENVELOPE_VERSION
  data: unknown
  agent_guidance?: string
}

export const okResult = (data: unknown, agentGuidance?: string): ToolResult => {
  const envelope: ToolResultEnvelope = {
    [TOOL_RESULT_ENVELOPE_KEY]: TOOL_RESULT_ENVELOPE_VERSION,
    data: data ?? null,
    ...(agentGuidance?.trim() && { agent_guidance: agentGuidance }),
  }

  return {
    content: [{ type: 'text', text: JSON.stringify(envelope) }],
  }
}

export const errorResult = (e: unknown): ToolResult => ({
  content: [{ type: 'text', text: JSON.stringify({ error: normalizeApiError(e) }) }],
  isError: true,
})
